import { useEffect, useRef, useState } from 'react';
import './info-card.css';
import { toPrettyTimeSince } from "../../prettyDate";

// Clamps long values (e.g. many turbine models) to two lines; click to expand, click again to collapse.
function CardValue({ value }) {
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [overflowing, setOverflowing] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (el && !expanded) setOverflowing(el.scrollHeight > el.clientHeight + 1);
    }, [value, expanded]);

    return (
        <h4
            ref={ref}
            className={`value ${expanded ? 'expanded' : ''} ${overflowing || expanded ? 'expandable' : ''}`}
            title={overflowing && !expanded ? String(value) : undefined}
            onClick={overflowing || expanded ? () => setExpanded(!expanded) : undefined}
        >
            {value}
        </h4>
    );
}

export default function InfoCards({ statistics, windfarmPage }) {
    if (!statistics) return null;

    const renderCard = (entry, pretty_value) => (
        <div key={entry.title} className={`info-card ${entry.color ? entry.color : ''}`}>
            <p className='info-card-title'>{entry.title}</p>
            <CardValue value={pretty_value} />
        </div>
    );

    if (windfarmPage) {
        const lastTwoWeeksEntry = statistics.find(entry => entry.title === "Last two weeks");
        const outsideIECEntry = statistics.find(entry => entry.title === "Unhandled strikes outside IEC (last two weeks)");

        const otherEntries = statistics.filter(entry => 
            entry.title !== "Last two weeks" && 
            entry.title !== "Unhandled strikes outside IEC (last two weeks)"
        );

        return (
            <div className='info-card-wrapper'>
                {lastTwoWeeksEntry && outsideIECEntry && (
                    <div className='info-card clustered'>
                        <p className='info-card-title'>{lastTwoWeeksEntry.title}</p>
                        <p className='clustered-value'>{lastTwoWeeksEntry.value}</p>
                        <p className='info-card-title'>Outside IEC</p>
                        <p className='clustered-value'>{outsideIECEntry.value} strikes</p>
                    </div>
                )}

                {otherEntries.map(entry => {
                    let pretty_value = entry.value;
                    if (entry.format === 'timestamp') {
                        pretty_value = toPrettyTimeSince(new Date(pretty_value));
                    }
                    return renderCard(entry, pretty_value);
                })}
            </div>
        );
    }

    return (
        <div className='info-card-wrapper'>
            {statistics.map(entry => {
                let pretty_value = entry.value;
                if (entry.format === 'timestamp') {
                    pretty_value = toPrettyTimeSince(new Date(pretty_value));
                }
                return renderCard(entry, pretty_value);
            })}
        </div>
    );
}